const validUnit = (unit: string) => (unit === 'quilometro' ? 'km/h' : unit);
const MAX_ATTEMPTS = 10;
const DEFAULT_VALUE = { val: 0, unit_measurement: 'km/h' };

export function normalizeSpeed(item: any): { val: number; unit_measurement: string } {
    try {
        let current: any = item;
        let foundUnit: string | undefined;
        let foundVal: number | undefined;
        let attempts = 0;

        for (let i = 0; i < MAX_ATTEMPTS; i++) {
            if (!current || typeof current !== 'object') break;
            if (foundUnit && foundVal) break;

            if (!foundUnit) {
                const unitCandidate = current.unit_measurement ?? current.unit;
                if (typeof unitCandidate === 'string') {
                    foundUnit = validUnit(unitCandidate);
                }
            }

            const valCandidate = current.val ?? current.value;

            if (!foundVal) {
                if (typeof valCandidate === 'number') {
                    foundVal = valCandidate;
                }
            }

            if (valCandidate && typeof valCandidate === 'object') {
                current = valCandidate;
                attempts = attempts + 1;
            } else {
                break;
            }
        }

        if (typeof foundVal === 'number') {
            return { val: foundVal, unit_measurement: foundUnit ?? 'km/h' };
        }
    } catch (err) {
        console.error('Erro ao normalizar velocidade:', err);
    }

    console.error('Falha ao converter speed (valor original):', item);
    return DEFAULT_VALUE;
}
